import { useEffect, useState } from "react";
import { LogoSvg } from "../components/loading";
import { hostsSettings, paymentTypes } from "../configs/app.config";
import { useParams } from "react-router-dom";
import ConfirmaitonModal from "../components/confirmation_modal";

export default function Payment() {
  const [isLoading, setLoading] = useState(false);
  const [confirmation, setConfirmation] = useState({
    status: false,
    title: "Ошибка",
    description: "Введите Email",
    cancelText: "Отмена",
  });
  const [order, setOrder] = useState(null);
  const [contact, setContact] = useState("");
  const { id } = useParams();

  useEffect(() => {
    async function getData() {
      setLoading(true);
      try {
        const response = await fetch(hostsSettings.apiPage + `/payment/${id}`, {
          headers: new Headers({
            Accept: "application/json",
            "Content-Type": "application/json; charset=utf-8",
          }),
          method: "GET",
          cache: "no-cache",
          mode: "cors",
          credentials: "include",
        });
        const res = await response.json();

        if (res.data.length === 0) {
          setOrder(null);
        } else {
          setOrder(res);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setOrder(null);
      } finally {
        setLoading(false);
      }
    }

    getData();
  }, [id]);

  function goNext() {
    let re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!contact.trim() || !re.test(contact)) {
      return setConfirmation({
        status: true,
        title: "Ошибка",
        description: "Введите Email",
        cancelText: "Отмена",
      });
    } else {
      setLoading(true);
      fetch(hostsSettings.apiPage + `/payment/${id}`, {
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json; charset=utf-8",
        }),
        method: "POST",
        cache: "no-cache",
        mode: "cors",
        credentials: "include",
        body: JSON.stringify({
          contact: contact,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (!res.error) {
            if (res.link) {
              window.location.href = res.link;
            } else {
              window.location.href = "https://crm.digitalkassa.ru/#/thxforpay";
            }
          } else {
            setConfirmation({
              status: true,
              title: "Ошибка",
              description: "Произошла ошибка в работе с банком, попробуйте оплатить по другой ссылке",
              cancelText: "Отмена",
            });
          }
        });
    }
  }

  return (
    <div className="paymentPage">
      {isLoading ? (
        <div className="loading_logo">
          <LogoSvg />
        </div>
      ) : null}

      {order ? (
        <>
          <h2>Заказа {id}</h2>
          <div className="product_list">
            {order.data.items.map((product, index) => {
              return (
                <div className="product_list_item" key={"paymentProd_" + index}>
                  <div className="product">
                    <div className="name">{product.name + " X " + product.quantity}</div>
                    <div className="price">{product.amount} ₽</div>
                  </div>
                  <div className="payment_method">
                    {paymentTypes.find((item) => item.id === product.payment_method).name}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="contact_place">
            <div className={"inputWithHint"}>
              <p>Введите свой Email</p>
              <input name="contact" onChange={(e) => setContact(e.target.value)} value={contact} />
              <button style={{ marginTop: 15 }} onClick={() => goNext()} className={"btn btn_tdk"}>
                <span>Продолжить</span>
              </button>
            </div>
          </div>
        </>
      ) : (
        <div style={{ textAlign: "center" }}>Заказ не найден или уже завершен</div>
      )}

      {confirmation.status == true ? (
        <ConfirmaitonModal
          closeAction={() => setConfirmation(false)}
          image="🤔"
          title={confirmation.title}
          description={confirmation.description}
          cancelText={confirmation.cancelText}
        />
      ) : (
        ""
      )}
    </div>
  );
}
